import React from 'react';

import feature1 from './assets/feature1.svg';
import feature2 from './assets/feature2.svg';
import feature3 from './assets/feature3.svg';


const FeaturesSection = () => {
    return (
        <section className="w-full bg-gray-50 py-16 md:py-24 px-4 sm:px-6 lg:px-8">
            {/* Section header — constrained + centered, matching hero width */}
            <div className="max-w-4xl mx-auto text-center">
                {/* Small Tag */}
                <span className="px-4 py-1 text-sm font-medium bg-gray-100 text-gray-800 rounded-full">
                    HOW NEXUS WORKS
                </span>

                {/* Title */}
                <h2 className="mt-6 text-3xl md:text-4xl font-semibold text-gray-900">
                    Managing your agency <br /> shouldn't be hard
                </h2>

                {/* Subtitle */}
                <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-base leading-relaxed">
                    We built Kayros from the ground up with one single constraint: make lead management, site creation, and client communication as easy as it can possibly be.
                </p>
            </div>

            {/* ── Row 1: 3-column card grid ── */}
            <div className="mt-12 max-w-6xl mx-auto">
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {/* Card 1 */}
                    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden flex flex-col text-left">
                        <div className="w-full overflow-hidden">
                            <img src={feature1} alt="Real-Time Data Analysis" className="w-full object-cover" />
                        </div>
                        <div className="px-6 pb-6 pt-4 flex flex-col flex-1">
                            <h3 className="text-base font-semibold text-gray-900">
                                Unified Communications
                            </h3>
                            <p className="mt-2 text-left text-gray-500 text-sm leading-relaxed">
                                Access all client messages, emails, and form submissions in one place to never miss a lead.
                            </p>
                        </div>
                    </div>

                    {/* Card 2 */}
                    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden flex flex-col text-left">
                        <div className="w-full flex items-center justify-center overflow-hidden">
                            <img src={feature2} alt="Customizable Dashboards" className="w-full object-cover" />
                        </div>
                        <div className="px-6 pb-6 pt-4 flex flex-col flex-1">
                            <h3 className="text-base font-semibold text-gray-900">
                                Customizable Dashboards
                            </h3>
                            <p className="mt-2 text-left text-gray-500 text-sm leading-relaxed">
                                Import leads instantly and organize them in a visual pipeline to track every deal.
                            </p>
                        </div>
                    </div>

                    {/* Card 3 */}
                    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden flex flex-col text-left">
                        <div className="w-full flex items-center justify-center overflow-hidden">
                            <img src={feature3} alt="Advanced Reporting Tools" className="w-full object-cover" />
                        </div>
                        <div className="px-6 pb-6 pt-4 flex flex-col flex-1">
                            <h3 className="text-base font-semibold text-gray-900">
                                Advanced Reporting Tools
                            </h3>
                            <p className="mt-2 text-left text-gray-500 text-sm leading-relaxed">
                                Publish your own professional agent website and list open properties by filling out a form.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;
